import { useCallback, useEffect, useEffectEvent, useState } from 'react';

import { useQuery } from '@tanstack/react-query';

import useDateText, { DateTextVariants } from '@/components/DateText/useDateText';
import { pastExportsOptions } from '@/features/DataHub/api';
import { createUniqueExportName } from '@/features/DataHub/modules/Export/services/ExportNameService';

const useExportName = () => {
  const [exportName, setExportName] = useState<string | null>(null);
  const { formatDateString } = useDateText();
  const { data: pastExports = [] } = useQuery(pastExportsOptions.list());

  const createExportName = useCallback((): string => {
    return createUniqueExportName(
      pastExports.map(e => ({ fileName: e.name })),
      (isoDate: string) => formatDateString(isoDate, DateTextVariants.FULL)
    );
  }, [pastExports, formatDateString]);

  const isNameInitialized = useEffectEvent(() => exportName !== null);

  useEffect(() => {
    if (isNameInitialized()) return;
    setExportName(createExportName());
  }, [createExportName]);

  return { exportName, setExportName, createExportName };
};

export default useExportName;
